import { render, staticRenderFns } from "./VueUploadMultipleImage.vue?vue&type=template&id=61d4011e&scoped=true&"
import script from "./VueUploadMultipleImage.vue?vue&type=script&lang=js&"
export * from "./VueUploadMultipleImage.vue?vue&type=script&lang=js&"
import style0 from "./VueUploadMultipleImage.vue?vue&type=style&index=0&id=61d4011e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4011e",
  null
  
)

export default component.exports